import { all, call, put, takeLatest, throttle } from 'redux-saga/effects';
import { fetchClient } from '../utilities/fetchClient';
import ActionTypes from '../actions/actionTypes';
import Env from '../Env';
import { getReportTypesSuccess, getReportTypesFailure } from '../actions/storeActions';
import { addToastAlert } from 'actions/toastAlertActions';
import Alert from 'constants/alert-messages';
import { MEDIUM_THROTTLE } from '../constants';
import SURVEYS from '../constants/surveys';

function* getCardOptionsByAccount(action) {
  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };

  try {
    const response = yield call(fetchClient, {
      url: `store-api/v1/cardoptions/favourite/account/${action.payload.accountNumber}?grandParentAccountNumber=${action.payload.grandParentAccountNumber}`,
      method: 'GET',
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });
    yield put({
      type: ActionTypes.STORE.GET_CARD_OPTIONS.SUCCESS,
      payload: {
        cardOptions: response,
      },
    });
  } catch (e) {
    yield put({ type: ActionTypes.STORE.GET_CARD_OPTIONS.FAILURE, payload: e });
  }
}

function* getVehicleTypes() {
  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };

  try {
    const response = yield call(fetchClient, {
      url: 'store-api/v1/vehicletype',
      method: 'GET',
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });
    yield put({
      type: ActionTypes.STORE.GET_VEHICLE_TYPES.SUCCESS,
      payload: {
        vehicleTypeResponse: response,
      },
    });
  } catch (e) {
    yield put({ type: ActionTypes.STORE.GET_VEHICLE_TYPES.FAILURE, payload: e });
  }
}

function* createCardOptions(action) {
  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };

  try {
    yield put(addToastAlert(Alert.ADD_FAV_LOADING));
    const response = yield call(fetchClient, {
      url: `store-api/v1/cardoptions/favourite?grandParentAccountNumber=${action.payload.grandParentAccountNumber}`,
      method: 'POST',
      body: action.payload.body,
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });
    yield put({
      type: ActionTypes.STORE.CREATE_CARD_OPTIONS.SUCCESS,
      payload: {
        createCardOptions: response,
      },
    });
    yield put(addToastAlert(Alert.ADD_FAV_SUCCESS, 'success'));
    if (Env.getIsZonkaEnabled() && typeof window._zf === 'function' && SURVEYS.ADDING_CARD_FAVOURITES) {
      window._zf('startForm', { 'widgetId': SURVEYS.ADDING_CARD_FAVOURITES, 'throttle': 'session' });
    }
  } catch (e) {
    yield put({ type: ActionTypes.STORE.CREATE_CARD_OPTIONS.FAILURE, payload: e });
    yield put(addToastAlert(Alert.ADD_FAV_ERROR, 'error'));
  }
}

function* updateCardOptions(action) {
  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };

  try {
    yield put(addToastAlert(Alert.EDIT_FAV_LOADING));
    const response = yield call(fetchClient, {
      url: `store-api/v1/cardoptions/favourite?grandParentAccountNumber=${action.payload.grandParentAccountNumber}`,
      method: 'PUT',
      body: action.payload.body,
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });
    yield put({
      type: ActionTypes.STORE.UPDATE_CARD_OPTIONS.SUCCESS,
      payload: {
        updateCardOptions: response,
      },
    });
    yield put(addToastAlert(Alert.EDIT_FAV_SUCCESS, 'success'));
  } catch (e) {
    yield put({ type: ActionTypes.STORE.UPDATE_CARD_OPTIONS.FAILURE, payload: e });
    yield put(addToastAlert(Alert.EDIT_FAV_ERROR, 'error'));
  }
}

// Report Types
function* getReportTypes() {
  try {
    const header = {
      'Ocp-Apim-Subscription-Key': Env.getApimKey(),
    };

    const response = yield call(fetchClient, {
      url: 'store-api/v1/reporttype',
      method: 'GET',
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });

    yield put(getReportTypesSuccess(response));
  } catch {
    yield put(getReportTypesFailure());
  }
}

export default function* storeSaga() {
  yield all([
    throttle(MEDIUM_THROTTLE, ActionTypes.STORE.GET_CARD_OPTIONS.REQUEST, getCardOptionsByAccount),
    takeLatest(ActionTypes.STORE.GET_VEHICLE_TYPES.REQUEST, getVehicleTypes),
    takeLatest(ActionTypes.STORE.CREATE_CARD_OPTIONS.REQUEST, createCardOptions),
    takeLatest(ActionTypes.STORE.UPDATE_CARD_OPTIONS.REQUEST, updateCardOptions),
    takeLatest(ActionTypes.STORE.GET_REPORT_TYPES.REQUEST, getReportTypes),
  ]);
}
